/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHead = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 10.806C3 5.959 6.87 2 11.677 2c4.8 0 8.235 4.087 8.36 8.737l1.781 3.335.014.025.012.025c.38.817.046 1.8-.772 2.206l-.002.001-1.026.506v1.815c0 .462-.239.814-.527 1.022a1.682 1.682 0 0 1-.671.274c-.332.063-.708.054-.846.054h-3v2h-2v-2c0-.724.248-1.365.842-1.728C14.324 17.976 14.864 18 15 18h3l.044-.001v-1.364c0-.632.355-1.217.928-1.5l.907-.449-1.718-3.214-.117-.222V11c0-3.862-2.779-7-6.367-7C8.005 4 5 7.032 5 10.806c0 1.955.993 3.898 2.364 5.18l.279.248.034.028.03.031 1.4 1.4-1.137 4.55-1.94-.485.863-3.451-.586-.586C4.435 16.125 3 13.543 3 10.806z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHead as Head };
